import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import { showSuccessToast } from "../utils/toast";
import { Alert, Button, Card, Form } from '@themesberg/react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';

import { API_URL, END_POINT_PAYMENT_TERMS } from '../const';

const getToken = () => {
  const rawToken = sessionStorage.getItem('quotetoken');
  return rawToken?.replace(/^"|"$/g, '');
};

export const PaymentTermForm = ({ onSuccess, onCancel, onSubmittingChange }) => {
  const formik = useFormik({
    initialValues: { name: '' },
    validationSchema: Yup.object({
      name: Yup.string().trim().required('Payment term is required'),
    }),
    onSubmit: async (values, { setSubmitting, setStatus, setErrors }) => {
      setStatus(null);
      onSubmittingChange?.(true);
      let result;
      try {
        const response = await axios.post(`${API_URL}${END_POINT_PAYMENT_TERMS}`, values, {
          headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
        });
        if (!response.data.status) {
          setStatus(response.data.message || 'Unable to create payment term. Please try again.');
          return;
        }
        result = response.data;
      } catch (error) {
        const errors = error.response?.data?.errors;
        if (errors) {
          setErrors(Object.fromEntries(
            Object.entries(errors).map(([field, messages]) => [
              field, Array.isArray(messages) ? messages[0] : messages,
            ])
          ));
        }
        setStatus(error.response?.data?.message || 'Unable to create payment term. Please try again.');
      } finally {
        setSubmitting(false);
        onSubmittingChange?.(false);
      }
      if (result) onSuccess(result);
    },
  });

  return (
    <Form noValidate onSubmit={formik.handleSubmit} aria-busy={formik.isSubmitting}>
      {formik.status && <Alert variant="danger">{formik.status}</Alert>}
      <Form.Group className="mb-3" controlId="payment-term-name">
        <Form.Label>Payment Term <span className="text-danger">*</span></Form.Label>
        <Form.Control
          type="text"
          autoFocus
          disabled={formik.isSubmitting}
          {...formik.getFieldProps('name')}
          isInvalid={formik.touched.name && !!formik.errors.name}
        />
        <Form.Control.Feedback type="invalid">{formik.errors.name}</Form.Control.Feedback>
      </Form.Group>
      <div className="create-record-form__actions d-flex justify-content-end gap-2 mt-2">
        {onCancel && (
          <Button type="button" variant="outline-secondary" onClick={onCancel} disabled={formik.isSubmitting}>
            Cancel
          </Button>
        )}
        <Button type="submit" variant="primary" className="btn-quote-blue" disabled={formik.isSubmitting}>
          {formik.isSubmitting ? 'Saving...' : 'Save'}
        </Button>
      </div>
    </Form>
  );
};

export const CreatePaymentTerm = () => {
  const navigate = useNavigate();

  const handleSuccess = async (result) => {
    showSuccessToast(result.message);
    navigate('/payment-terms');
  };

  return (
    <Card border="light" className="bg-white shadow-sm mb-4">
      <Card.Body>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h5 className="mb-0">Create Payment Term</h5>
          <Link to="/payment-terms" className="btn-quote-back">Back to Listing</Link>
        </div>
        <PaymentTermForm onSuccess={handleSuccess} />
      </Card.Body>
    </Card>
  );
};
